import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel, pixelEnabled } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { BeforeAfter } from './components/BeforeAfter';
import { MeetingSelector } from './components/MeetingSelector';
import { LookInsideSection } from './components/LookInsideSection';
import { SolutionSection } from './components/SolutionSection';
import { ValuesBand } from './components/ValuesBand';
import { YearPlanSection } from './components/YearPlanSection';
import { MeetingsList } from './components/MeetingsList';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = pixelEnabled ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'fr';
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" lang="fr" className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="nuhged3fk1rn">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="swqchiblnjxz" />}
      <TopBar data-id="element-2" data-mp="356sn718lka4" />
      <main data-id="element-3" data-mp="34x4lozr5n72">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="38kvegdtbvi3" />
        <StatsBand data-id="element-5" data-mp="3udknlyaisybg" />
        <BeforeAfter data-id="element-6" data-mp="3ubzrw5cgz9c0" />
        <MeetingSelector data-id="element-7" data-mp="3ucje3y95kjvu" />
        <LookInsideSection pageImages={pageImages} data-id="element-8" data-mp="d4nvlgp3tk2e" />
        <SolutionSection data-id="element-9" data-mp="d3crffrqyaar" />
        <ValuesBand data-id="element-10" data-mp="d2l7513lnyzs" />
        <YearPlanSection data-id="element-11" data-mp="85uihpdqbv2r" />
        <MeetingsList data-id="element-12" data-mp="85b8qvy8gczt" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-13" data-mp="864b7kq5sgc5" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-14" data-mp="3gl4qfe4avuig" />
        <GuaranteeSection data-id="element-15" data-mp="3glo0k8nplelx" />
        <FaqSection data-id="element-16" data-mp="3bmbehq4nwbke" />
        <FinalCta data-id="element-17" data-mp="3bmthr6pqrq1t" />
      </main>
      <Footer data-id="element-18" data-mp="3bnmk7vho3te5" />
      <StickyCta data-id="element-19" data-mp="3bo4kd37garrc" />
    </div>;
}